export default "__VITE_ASSET__RWVPMKam__"